import * as yup from "yup";

export const filtrosEntregadoresSchema =  yup.object().shape({
  nome: yup.string(),
  email: yup.string(),
  telefone: yup.string()
});
  